import React, { useEffect, useState } from 'react';
import useDebounce from 'hooks/useDebounce';
import useSWR from 'swr';
import svcs from 'services';
import { emptyISearchFilterRequest, ISearchFilterRequest } from 'repositories/SearchRepository2';
import { emptyCategory, ISearchedCategory } from 'repositories/category/CategoryRepository';
import { langutil } from '../../../language/langutil';
import { getDateRange } from 'mainpage/toparea/srchinput/srchutil';
import parse from 'html-react-parser';
import { getHighlightedTextFromHtml } from 'util/commonUtils';
import { join } from 'lodash-es';
import { buildSearchApiUrl, prepareSearchKeyword } from 'util/srchurl';

export interface ISearchedCategoryExt extends ISearchedCategory {
  itemModels: string[];
  related_models;
  //name;

  category;
  url;
}

export type CATEGORY_RSLT = { totalCount; items: any[] };
export const useRelatedCategory = (input: string): CATEGORY_RSLT => {
  const val = useDebounce<ISearchFilterRequest>(
    {
      ...emptyISearchFilterRequest,
      searchKeyword: input,
      lang: svcs.svcLang.lang(),
      page: 1,
      size: 5,
    },
    500
  );
  const [url, setUrl] = useState<string>();
  const { data } = useSWR<any>(val.searchKeyword && url && [url]);
  const [rslt, setRslt] = useState<CATEGORY_RSLT>();

  useEffect(() => {
    const p = { ...val };
    if (
      p.category !== emptyCategory ||
      p.doctype !== 'DEFAULT' ||
      p.orderby !== 'ACCURACY' ||
      p.rangetype !== 'DEFAULT' ||
      p.tags.length !== 0
    ) {
      setUrl(undefined);
      return;
    }

    p.searchKeyword = prepareSearchKeyword(p.searchKeyword, p.resultType);
    const reqlang = langutil.getSrchLang(p.lang);
    const inner = `index=category_${reqlang}&indexsize=${val.size}&query=${encodeURIComponent(
      p.searchKeyword
    )}&page=${val.page}${getDateRange(val.daterange)}&filter=category@expose:true`;
    setUrl(buildSearchApiUrl(inner));
  }, [val]);

  useEffect(() => {
    const p = { ...val };
    if (
      p.category !== emptyCategory ||
      p.doctype !== 'DEFAULT' ||
      p.orderby !== 'ACCURACY' ||
      p.rangetype !== 'DEFAULT' ||
      p.tags.length !== 0
    ) {
      setRslt({ totalCount: 0, items: [] });
      return;
    }

    const items: any[] = data?.result[0].items.map((ele: ISearchedCategoryExt) => {
      if (ele.related_models && !Array.isArray(ele.related_models)) {
        ele.related_models = ele.related_models.split(';');
      }

      let splittedCategory = ele.category.split('/');
      //ele.splittedCategory = ele.name;
      let itemModels = [];

      ele.related_models &&
        ele.related_models.map((model) => {
          if (model.includes("<b class='search_highlight'>")) {
            itemModels.push(model);
          }
        });

      ele.itemModels = itemModels;
      ele.highlightedResultElement = (
        <div className={'category-search-suggest-item'}>
          {parse(getHighlightedTextFromHtml(join(splittedCategory, '/')))}
        </div>
      );
      ele.url = `/product/category/${ele.id}`;
      return ele;
    });

    setRslt({ totalCount: data?.totalCount, items });
  }, [data]);

  return rslt;
};
